export const extractFirstTextFromHTML = (
    htmlString: string,
    maxChars = 20
): string => {
    if (!htmlString) return '';

    // Remove tags
    const withoutTags = htmlString.replace(/<[^>]*>/g, ' ');

    // Decode HTML entities (browser DOM if available, otherwise fallback)
    const decodeEntities = (s: string): string => {
        if (
            typeof document !== 'undefined' &&
            typeof document.createElement === 'function'
        ) {
            const textarea = document.createElement('textarea');
            textarea.innerHTML = s;
            return textarea.value;
        }

        // Fallback: handle numeric entities and common named entities
        return s.replace(/&(#x?[0-9a-fA-F]+|[a-zA-Z]+);/g, (_m, token) => {
            if (token[0] === '#') {
                const isHex = token[1] === 'x' || token[1] === 'X';
                const num = isHex
                    ? parseInt(token.slice(2), 16)
                    : parseInt(token.slice(1), 10);
                return Number.isNaN(num) ? _m : String.fromCodePoint(num);
            }
            const map: Record<string, string> = {
                amp: '&',
                lt: '<',
                gt: '>',
                quot: '"',
                apos: "'",
                nbsp: '\u00A0',
            };
            return map[token] ?? _m;
        });
    };

    const decoded = decodeEntities(withoutTags).replace(/\s+/g, ' ').trim();

    if (decoded.length === 0) return '';

    const chars = Array.from(decoded); // preserves Unicode code points
    if (chars.length <= maxChars) return chars.join('');
    return chars.slice(0, maxChars).join('') + '...';
};
